// ALERTS FORM ACTIONS
export var ALERTS_FORM_INITIALIZE = 'ALERTS_FORM_INITIALIZE';
export var ALERTS_FORM_CLOSE_ACCORDION = 'ALERTS_FORM_CLOSE_ACCORDION';
export var ALERTS_FORM_OPEN_ACCORDION = 'ALERTS_FORM_OPEN_ACCORDION';
export var ALERTS_FORM_RESET_DATA = 'ALERTS_FORM_RESET_DATA';
export var ALERTS_FORM_SET_IS_LOADING = 'ALERTS_FORM_SET_IS_LOADING';
export var ALERTS_FORM_FORCE_CLOSE_ACCORDION = 'ALERTS_FORM_FORCE_CLOSE_ACCORDION';
export var ALERTS_FORM_PREFERENCE_UPDATE_ERROR = 'ALERTS_FORM_PREFERENCE_UPDATE_ERROR';
export var ALERTS_FORM_ATTRIBUTE_CHANGE = 'ALERTS_FORM_ATTRIBUTE_CHANGE';
export var ALERTS_FORM_DELIVERY_CHANGE = 'ALERTS_FORM_DELIVERY_CHANGE';
export var ALERTS_FORM_SET_ERROR = 'ALERTS_FORM_SET_ERROR';
export var ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS = 'ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS';
// ALERTS DATA ACTIONS
export var ALERTS_DATA_INITIALIZE = 'ALERTS_DATA_INITIALIZE';
export var ALERTS_DATA_SET_IS_LOADED = 'ALERTS_DATA_SET_IS_LOADED';
export var ALERTS_DATA_SET_ERROR = 'ALERTS_DATA_SET_ERROR';
export var ALERTS_DATA_UPDATE_ALERT = 'ALERTS_DATA_UPDATE_ALERT';
export var ALERTS_DATA_RESET = 'ALERTS_DATA_RESET';
export var ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS = 'ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS';
export var ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER = 'ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER';
export var ALERTS_DATA_SET_TERMS_CONSENT_ERROR = 'ALERTS_DATA_SET_TERMS_CONSENT_ERROR';
export var ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING = 'ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING';
